import { SelectPlus } from 'Components/SelectPlus';

// Estado del vehículo: 'new' -> is_new=True, 'used' -> is_new=False (backend)
const VEHICLE_STATE_OPTIONS = [
  { label: 'Nuevo', value: 'new' },
  { label: 'Usado', value: 'used' },
];

export const SelectVehicleState = ({ mode = 'single', ...selectProps }) => {
  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar estado${isSingleMode ? '' : 's'}`;

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      options={VEHICLE_STATE_OPTIONS}
      {...selectProps}
    />
  );
};
